export interface Equipment {
  Error: boolean;
  Message: string;
  equipments?: EquipmentsEntity[] | null;
  Equipment?: EquipmentsEntity[] | null;
}

export class EquipmentModel {
  equipment_id?: number;
  latentdescap: number;
  cddratio: string;
  ratercompid: string;
  equipmentname: string;
  hp17fcap: number;
  hp47fcap: string;
  equipmentdescription: string;
  equiptype: string;
  condmfr: string;
  condensermn: string;
  evapmfr: string;
  evapmn: string;
  ahrino: string;
  listedeer: number;
  listedseer: number;
  hp17fcop: number;
  hpahrilistedhpsf: number;
  fanspeed: string;
  compressortype: string;
  sensibledescap: number;
  totaldescap: number;
  furnmfre: string;
  furnacemn: string;
  listedafue: number;
  furnoutput: number;
}

export interface EquipmentsEntity {
  equipment_id: number;
  hvaccontractor_id: string;
  equipmentname: string;
  equipmentdescription: string;
  condmfr: string;
  condensermn: string;
  evapmfr: string;
  evapmn: string;
  ahrino: string;
  listedeer: number;
  listedseer: number;
  metering?: null;
  refrigerant?: null;
  fanspeed: string;
  latentdescap: number;
  sensibledescap: number;
  totaldescap: number;
  ahricertattached?: null;
  hpahrilistedhpsf: number;
  hp17fcap: number;
  hp17fcop: number;
  hp47fcap: string;
  hp47fcop?: number;
  furnacemn: string;
  listedafue: number;
  furnmfr?: null;
  furnoutput: number;
  equipmentcomplete?: null;
  ratercompid: string;
  compressortype: string;
  equipmenttype?: null;
  coolingsizinglimit?: null;
  loadsenshtratio?: null;
  coolsizingpct?: null;
  cddratio: string;
  coolsizepctlimit?: string;
  heatsizinglimit?: null;
  heatsizingpct?: number;
  heatsizepctlimit?: null;
  hvac_design_id?: number;
  furnacena?: null;
  equiptype: string;
  cddratio2?: null;
  furnmfre: string;

}
